import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ICardResponse } from '../models/cards.interface';
import { handleRouteError } from './route-helpers/route-error';


/**
 * Get a list of cards
 * 
 * @returns {object} the api response
 */
const GetCardList = async (): Promise<ICardResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get('/cards', {
      params: {
        wpID: userId,
        cardNumber: 0
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting card data');
    throw(error);
  }
}

export default GetCardList;